import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountTypeLabelPayoutProcess'
})
export class AccountTypeLabelPayoutProcessPipe implements PipeTransform {

  transform(value: string, args?: any): string {
    switch (value) {
      case 'SAVING':
        return 'A';
      case 'CHECKING':
        return 'C';
      case 'MASTER':
        return 'M';
      default:
        return value;
    }
  }

}
